/* eslint-disable consistent-return */
const GetNavigationViewConfigByOrderState = orderState => {
  switch (orderState) {
    case 'InProgress': {
      return {
        navRail: true,
        navSections: [
          {
            id: 1,
            header: 'Purchase Process',
            status: 'In progress',
            containsNavItems: true
          },
          {
            id: 2,
            header: 'Finalize Purchase',
            status: null,
            containsNavItems: false
          }
        ]
      };
    }
    case 'Underwriting': {
      return {
        navRail: true,
        navSections: [
          {
            id: 1,
            header: 'Purchase Process',
            status: 'Done',
            containsNavItems: false
          },
          {
            id: 2,
            header: 'Finalize Purchase',
            status: 'In progress',
            containsNavItems: true
          }
        ]
      };
    }
    case 'OrderPlaced': {
      return {
        removePadding: true,
        navRail: false,
        navSections: []
      };
    }
    default:
      return {
        navRail: true,
        navSections: [
          {
            id: 1,
            header: 'Purchase Process',
            status: 'Done',
            containsNavItems: true
          },
          {
            id: 2,
            header: 'Finalize Purchase',
            status: 'Done',
            containsNavItems: false
          }
        ]
      };
  }
};

export default GetNavigationViewConfigByOrderState;
